// Fetches system status from the system-status Supabase Edge Function.
// Tokens live server-side in the edge function — never exposed to the browser.

import { RAW_URL as SUPABASE_URL, SUPABASE_KEY } from '../../../shared/functions/supabaseClient.js'

const EDGE_URL = `${SUPABASE_URL}/functions/v1/system-status`
const REST_URL = `${SUPABASE_URL}/rest/v1`

export async function fetchSystemStatus () {
  const res = await fetch(EDGE_URL, {
    headers: {
      Authorization: `Bearer ${SUPABASE_KEY}`,
      'Content-Type': 'application/json'
    }
  })
  if (!res.ok) throw new Error(`system-status: ${res.status}`)
  return res.json()
}

// Fetch 90-day uptime data directly from Supabase (public table, no secrets needed)
export async function fetchUptime () {
  const res = await fetch(
    `${REST_URL}/system_uptime?select=service,checked_at,status,latency_ms,message&order=checked_at.asc&limit=3000`,
    {
      headers: {
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`
      }
    }
  )
  if (!res.ok) return {}
  const rows = await res.json()
  // Group by service name → array of day records
  const byService = {}
  for (const r of rows) {
    if (!byService[r.service]) byService[r.service] = []
    byService[r.service].push(r)
  }
  return byService
}
